import { render } from "./AddressLaboratory.vue?vue&type=template&id=67727c82"
import script from "./AddressLaboratory.vue?vue&type=script&lang=js"
export * from "./AddressLaboratory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__